import { message } from 'antd'
import modalProps from '../modalProps'
import { createSubOrder, updateSubOrder } from '../../../HttpRequests/subOrders'
import handleException from '../../../Core/Helpers/handleException'
import fetch from '../../../Screens/SubOrder/Services/fetch'

export default (values) => async (dispatch) => {

  const { subOrder, orderItemIds } = modalProps()

  const data = {
    reference: values.reference,
    subcontractor_id: values.subcontractor_id,
    project_id: values.project_id,
    user_id: values.user_id,
    date: values.date,
    vat_perc: values.vat_perc,
    retention_percentage: values.retention_percentage || null,
    notes: values.notes || null,
    set_percentage: values.set_percentage || null,
    set_amount: values.set_amount || null,
    status_key: values.status_key || null,
    approved_by: values.approved_by || null,
    approved_at: values.approved_at || null,
  }

  let response

  try {

    if (subOrder) {

      response = await updateSubOrder({ id: subOrder.id, data })

      message.success(`Updated "${response.data.reference}"`)

      // Refresh SubOrder data to show updated status and fields
      await dispatch(fetch())

    } else {

      data.order_item_ids = orderItemIds

      response = await createSubOrder({ data })

      message.success(`Created "${response.data.reference}"`)

    }

    modalProps().onClose(response.data)

  } catch (error) {

    handleException(error)

  }

}
